/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   sitemap bizos
 */

import { Bizo, autoclass } from './base'
import { SerializableMap } from './serializableMap'
import type {
  RawSitemapCountsResponse,
  RawSitemapEntry,
  RawSitemapResponse,
  SitemapCounts,
  SitemapCountsResponse as SitemapCountsResponseType,
  SitemapEntry as SitemapEntryType,
  SitemapResponse as SitemapResponseType,
} from './sitemap.types'

export const SitemapEntry: typeof SitemapEntryType = autoclass<SitemapEntryType, RawSitemapEntry>(
  'SitemapEntry',
  class SitemapEntry extends Bizo<SitemapEntryType, RawSitemapEntry> {},
  {
    title: 'title',
    url: ({ _data: { url } }: SitemapEntryType) =>
      // TODO(apartments-for-rent): revert this change once we want to expose /listings/ in sitemap (end of June 2025)
      url.replace('/listings/', '/apartments-for-rent/'),
  }
)
export type SitemapEntry = SitemapEntryType

export const SitemapResponse: typeof SitemapResponseType = autoclass<
  SitemapResponseType,
  RawSitemapResponse
>(
  'SitemapResponse',
  class SitemapResponse extends Bizo<SitemapResponseType, RawSitemapResponse> {},
  {
    sitemap: { isArray: true, name: 'sitemap', type: SitemapEntry },
  }
)
export type SitemapResponse = SitemapResponseType

export const SitemapCountsResponse: typeof SitemapCountsResponseType = autoclass<
  SitemapCountsResponseType,
  RawSitemapCountsResponse
>(
  'SitemapCountsResponse',
  class SitemapCountsResponse extends Bizo<SitemapCountsResponseType, RawSitemapCountsResponse> {},
  {
    count: ({ _data: { count } }: SitemapCountsResponseType) =>
      new SerializableMap(
        Object.entries(count) as Array<[keyof typeof count, (typeof count)[keyof typeof count]]>
      ),
  }
)
export type SitemapCountsResponse = SitemapCountsResponseType

export type { SitemapCounts }
